import { Injectable } from '@angular/core';
import Qty from 'js-quantities';

@Injectable({
    providedIn: 'root',
})

export class Helpers {
    constructor() { }

    getLogLevelString(logLevel: number): string {
        switch (logLevel) {
            case 0: return "Fatal";
            case 1: return "Error";
            case 2: return "Warning";
            case 3: return "Info";
            case 4: return "Debug";
            case 5: return "Trace";
            default: return "Unknown";
        }
    }

    getJobStatusString(jobStatus: number): string {
        switch (jobStatus) {
            case 0: return "New";
            case 10: return "Queued For Meshing";
            case 20: return "Waiting For Mesh";
            case 21: return "Queued For Sim Setup";
            case 22: return "Sim Setup";
            case 25: return "Queued For Mesh Conversion";
            case 26: return "Mesh Conversion";
            case 30: return "Queued For Solving";
            case 40: return "Solving";
            case 50: return "Queued For Post Process";
            case 60: return "Post Process";
            case 70: return "Complete";
            case 80: return "Quarantined";
            default: return "Unknown";
        }
    }

    getJobTypeString(jobType: string): string {
        // Split the string by underscore
        let split = jobType.split('_');

        let displayType = "";
        switch (split[0]) {
            case "electromagnetic":
                displayType = "Transient Electromagnetic";
                break;
            case "mechanical":
                displayType = "Mech";
                break;
            case "thermal":
                displayType = "Thermal";
                break;
            case "frozenperm":
                displayType = "Frozen Permeability"
            default:
                displayType = split[0];

        }

        if (split[1] != "none") {
            displayType += " " + split[1].toUpperCase();
        }

        if (split[2] != "none") {
            displayType += " " + split[2].toUpperCase();
        }

        return displayType;
    }

    job2winding(job: any): any {
        let winding = {
            "number_slots": null,
            "number_phases": null,
            "number_layers": null,
            "coil_span": null,
            "turns_per_coil": null,
            "empty_slots": null,
            "number_poles": null,
            "symmetry": null,
            "terminal_resistance": null,

        };
        for (let i = 0; i < job.data.length; i++) {
            if (job.data[i].name === "terminal_resistance") {
                winding[job.data[i].name] = job.data[i].value
                console.debug("Winding parameter: " + job.data[i].name + " = " + job.data[i].value);
            }
            else if (job.data[i].section === "winding" || job.data[i].name === "number_poles" || job.data[i].name === "number_slots") {
                winding[job.data[i].name] = job.data[i].value.magnitude[0];
                console.debug("Winding parameter: " + job.data[i].name + " = " + job.data[i].value.magnitude[0]);
            } else {
                console.debug("Not a winding parameter: " + job.data[i].name);
            }
        }
        return winding;
    }

    winding2array(winding: any): string[][] {
        const winding_layout = winding["winding_layout"];
        console.debug(`Making winding array from ${winding} and ${winding_layout}`);
        // force parameters to be integers
        const number_slots = Math.floor(winding["number_slots"] as number);
        const number_phases = Math.floor(winding["number_phases"] as number);
        const number_layers = Math.floor(winding["number_layers"] as number);

        let winding_array: string[][] = Array(number_slots).fill(null).map(() => Array(number_layers).fill(""));
        for (let phase = 0; phase < number_phases; phase++) {
            for (let layer = 0; layer < number_layers; layer++) {
                for (let slot of winding_layout[phase][layer]) {
                    if (slot > 0) {
                        winding_array[slot - 1][number_layers - (1 + layer)] = String.fromCharCode('a'.charCodeAt(0) + phase);
                    } else {
                        winding_array[-slot - 1][number_layers - (1 + layer)] = String.fromCharCode('A'.charCodeAt(0) + phase);
                    }
                }
            }
        }
        console.debug(winding_array);
        return winding_array;
    }

    job2geometry(job: any): any {

        let geometry = {
            "rotor": {},
            "stator": {}
        }

        // For each field on job.data where section = "rotor", add it to the rotor dictionary
        for (let i = 0; i < job.data.length; i++) {
            if (job.data[i].section === "rotor") {

                let unit = job.data[i].value.units ? job.data[i].value.units[0] : undefined;
                // If unit is defined, convert to base units
                if (unit !== undefined && unit.name !== "" && unit.name !== 'count') {
                    let jobQty = new Qty(job.data[i].value.magnitude[0] + " " + unit.name);
                    let kind = jobQty.kind();
                    geometry.rotor[job.data[i].name] = kind == 'length'
                        ? jobQty.baseScalar * 1000
                        : jobQty.baseScalar;
                }
                else {
                    geometry.rotor[job.data[i].name] = job.data[i].value.magnitude[0];
                }

                continue;
            }

            if (job.data[i].section === "stator") {
                let unit = job.data[i].value.units ? job.data[i].value.units[0] : undefined;
                // If unit is defined, convert to base units
                if (unit !== undefined && unit.name !== "" && unit.name !== 'count') {
                    let jobQty = new Qty(job.data[i].value.magnitude[0] + " " + unit.name);
                    let kind = jobQty.kind();
                    geometry.stator[job.data[i].name] = kind == 'length'
                        ? jobQty.baseScalar * 1000
                        : jobQty.baseScalar;
                }
                else {
                    geometry.stator[job.data[i].name] = job.data[i].value.magnitude[0];
                }
            }
        }

        return geometry;
    }

    snake2Pascal(str) {
        str += '';
        str = str.split('_');
        for (var i = 0; i < str.length; i++) {
            str[i] = str[i].slice(0, 1).toUpperCase() + str[i].slice(1, str[i].length);
        }
        return str.join(' ');
    }

    getMaterialById(materials: any[], id: string) {
        let material = materials.find(m => m.id == id);
        return material;
    }

    getMaterialNameById(materials: any[], id: string) {
        let material = materials
            ? this.getMaterialById(materials, id)
            : null;

        return material ? material.name : "";
    }

    deepCopy(obj) {
        var copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    getJobIsLocked(job: any): boolean {
        return job && (
            (job.status > 0 && job.status != 80) ||
            job.is_deleted === true ||
            job.is_archived === true);
    }

    getJobHasRollup(job: any): boolean {
        // Iterate through job.artifacts.  If any of them have a type of "ARCHIVE", return true
        for (let i = 0; i < job.artifacts.length; i++) {
            if (job.artifacts[i].type === "ARCHIVE") {
                return true;
            }
        }
        return false;
    }

    getIsExampleJobId(targetJobId: string) {
        return targetJobId != null && targetJobId.split('_').length == 3;
    }

    getJobIsExisting(job: any): boolean {
        return (
            job != null &&
            typeof job !== 'undefined' &&
            job.id != null &&
            job.id != '0' &&
            job.id != '' &&
            !this.getIsExampleJobId(job.id)
        );
    }

    getLogClass(log: string) {
        if (log.includes('ERROR')) {
            return 'log-danger';
        } else if (log.includes('WARN')) {
            return 'log-warning';
        } else {
            return '';
        }
    }

    getJobStringField(job: any, fieldName: string): string {
        let field = job.string_data.find((f: any) => f.name === fieldName);
        if (field) {
            return field.value;
        } else {
            return '';
        }
    }
}

